"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scan_1 = require("./scan");
Object.defineProperty(exports, "scan", { enumerable: true, get: function () { return scan_1.scan; } });
var inspect_1 = require("./inspect");
Object.defineProperty(exports, "inspect", { enumerable: true, get: function () { return inspect_1.inspect; } });
//# sourceMappingURL=index.js.map